import React, { useEffect, useState } from "react";

import { imgBaseUrl } from "../../../api/api";

import { formatToDate } from "../../master/FormatToDateTime";

import "./StudentAdmissionFrom3.css";
import { formatTime } from "../../master/Master";


export default function StudentAdmissionFrom3({ data }) {
    const [setting, setSetting] = useState({});
    const client = JSON.parse(localStorage.getItem("client"));






    useEffect(() => {
        setSetting(JSON.parse(localStorage.getItem("setting") ?? {}));
    }, []);

    const educationDetails = data?.education_details
        ? typeof data.education_details === "string"
            ? JSON.parse(data.education_details)
            : data.education_details
        : null;

    const installments = data?.student_batch_info?.installments
        ? typeof data.student_batch_info.installments === "string"
            ? JSON.parse(data.student_batch_info.installments)
            : data.student_batch_info.installments
        : null;

    const fullName = (data?.name ?? "").trim();
    const nameParts = fullName.split(" ").filter(Boolean);
    const firstName = nameParts[0] ?? "";
    const lastName = nameParts.slice(1).join(" ");

    const genderValue = (data?.gender ?? "").toLowerCase();
    const isMale = genderValue.startsWith("m");
    const isFemale = genderValue.startsWith("f");

    // NOTE: batch_option / payment_type field names are assumed —
    // rename below to whatever keys your API actually sends.
    const batchOption = (data?.student_batch_info?.batch_option ?? "").toLowerCase();
    const isOnline = batchOption === "online";
    const isOffline = batchOption === "offline";

    const paymentType = (data?.student_batch_info?.payment_type ?? "").toLowerCase();
    const emiCount = data?.student_batch_info?.emi?.length || 0;

    const isInstallment = emiCount > 0;
    const isFullPayment = emiCount === 0;

    return (
        <>
            <style>
                {`
                .a4-page-3 {
  --accent: #2fa360;
  --accent-light: #eaf8ef;
  --ink: #1a1a1a;

  width: 210mm;
  min-height: 297mm;
  margin: 0 auto 24px auto;
  padding: 16mm 12mm 12mm 12mm;
  background: #fff;
  position: relative;
  box-sizing: border-box;
  font-family: "Segoe UI", Arial, sans-serif;
  font-size: 13px;
  color: var(--ink);
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  border-top: 6px solid var(--accent);
}

.a4-page-3::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 65%;
  height: 65%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.07;
  transform: translate(-50%, -50%);
  z-index: 0;
  pointer-events: none;
}

.a4-page-3 > * {
  position: relative;
  z-index: 1;
}

.page-break {
  page-break-after: always;
  break-after: page;
}

/* ---- decorative elements (TIFA-style letterhead flair) ---- */

.a4-page-3 {
  border-top: 8px solid #2fa360;
}
.corner-ribbon {
  position: absolute;
  top: 0;
  left: 0;

  width: 70%;
  height: 120px;

  background: #8bc34a;

  clip-path: polygon(0 0, 100% 0, 100% 0, 0 100%);
}
.enrollment-line {
  min-width: 120px;
  display: inline-block;
}

.registration-no {
  display: inline-block;
  border-bottom: 1px dotted #000;
  line-height: 1.2;
}
.registration-inline::after {
  content: "..";
  margin-left: 4px;
  letter-spacing: 1px;
}
.bottom-accent-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 8px;
  background: var(--accent);
  z-index: 0;
  pointer-events: none;
}

.address-line {
  width: 100%;
  border-bottom: 1px dotted #555;
  margin-top: 4px;
}

.watermark-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-25deg);
  font-size: 64px;
  font-weight: 800;
  color: rgba(31, 122, 77, 0.07);
  white-space: nowrap;
  z-index: 0;
  pointer-events: none;
  text-transform: uppercase;
  letter-spacing: 4px;
  max-width: 90%;
  overflow: hidden;
}

.header-center {
  margin-bottom: 6px;
}

.institute-name {
  font-weight: 800;
  font-size: 21px;
  color: var(--ink);
  letter-spacing: 0.3px;
  display: block;
}

.institute-meta {
  display: block;
  color: #444;
}

.logo-badge {
  width: 150px;
}

.logo-img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}

.admission-title {
  display: inline-block;
  font-size: 24px;
  font-weight: 800;
  letter-spacing: 1.5px;
  color: var(--accent);
  text-transform: uppercase;
  position: relative;
  padding-bottom: 10px;
}

.admission-title::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 64px;
  height: 3px;
  border-radius: 2px;
  background: var(--accent);
}

.title-divider {
  position: relative;
  width: 70%;
  max-width: 360px;
  height: 1px;
  background: #bbb;
  margin: 8px auto 0 auto;
}

.title-dot {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--accent);
  transform: translate(-50%, -50%);
}

.instruction-banner {
  background: var(--ink);
  color: #fff;
  text-align: center;
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  padding: 6px 10px;
  margin: 4px 0 16px 0;
  border-radius: 3px;
}

/* ---- form fields ---- */

.field-box {
  border: 1.5px solid var(--accent);
  border-radius: 4px;
  padding: 3px 8px;
  min-height: 24px;
  background: #fff;
}

.field-line {
  display: inline-block;
  border-bottom: 1px dotted #555;
  min-width: 120px;
  padding: 0 4px 1px 4px;
  font-weight: 600;
}

.field-line.w-75 {
  min-width: 60%;
}

.field-line.w-100 {
  min-width: 100%;
}

.declaration-text {
  font-size: 12.5px;
  margin: 10px 0;
  line-height: 1.5;
}

.checkbox-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border: 1.5px solid var(--ink);
  border-radius: 2px;
  font-size: 11px;
  font-weight: 700;
}

.checkbox-box.checked {
  background: var(--accent);
  border-color: var(--accent);
  color: #fff;
}

.photo-box {
  width: 100%;
  max-width: 130px;
  height: 150px;
  border: 2px solid var(--accent);
  border-radius: 4px;
  object-fit: cover;
}

.section-bar {
  font-weight: 700;
  font-size: 13.5px;
  background: var(--ink);
  color: #fff;
  padding: 6px 10px;
  margin: 14px 0 8px 0;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  text-align: center;
}

.section-heading {
  font-weight: 700;
  font-size: 14px;
  margin: 10px 0 10px 0;
  padding-bottom: 4px;
  /* border-bottom: 1px solid #ccc; */
}

.academic-table th,
.installment-table th {
  background: #f4f6f5;
}

.academic-table th,
.academic-table td,
.installment-table th,
.installment-table td {
  font-size: 12px;
  padding: 6px 8px;
  vertical-align: middle;
}
/* 
.terms-list {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
}

.terms-list li {
  position: relative;
  padding-left: 20px;
  margin-bottom: 7px;
  font-size: 12.5px;
  line-height: 1.5;
}

.terms-list li::before {
  position: absolute;
  left: 0;
  top: 0;
  color: var(--accent);
  font-weight: 700;
} */



/* /// */

.terms-list p {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
}

.terms-list p {
  position: relative;
  padding-left: 20px;
  margin-bottom: 7px;
  font-size: 12.5px;
  line-height: 1.5;
}

.terms-list p::before {
  position: absolute;
  left: 0;
  top: 0;
  color: var(--accent);
  font-weight: 700;
}

.signature-box {
  width: 100%;
  max-width: 220px;
  height: 64px;
  border: 1px solid var(--ink);
  border-radius: 3px;
  margin: 0 auto;
}

@media print {
  .a4-page-3 {
    box-shadow: none;
    margin: 0;
  }
}

          .a4-page-3::before{
            background-image: url(${imgBaseUrl + setting?.logo_img});
          }
        `}
            </style>
            <div id="PrintDiv">
                {/* ---------------- FRONT PAGE ---------------- */}
                <div className="a4-page-3 page-break p-3">
                    <div className="corner-ribbon" aria-hidden="true"></div>
                    <div className="bottom-accent-bar" aria-hidden="true"></div>
                    {!setting?.logo_img && (
                        <div className="watermark-text" aria-hidden="true">
                            {setting?.name}
                        </div>
                    )}

                    <div className="row  mb-3">

                        {/* Enrollment */}
                        <div className="col-3 mt-2">
                            <span className="fw-bold">Enrollment No.</span>

                            <span className="registration-no ms-2 text-danger fw-bold ">
                                {data?.registration_no ?? ""}
                            </span>
                        </div>

                        {/* Logo + Institute Details */}
                        <div className="col-6 text-center">

                            <div className="logo-badge mx-auto mb-2">
                                <img
                                    src={imgBaseUrl + setting?.logo_img}
                                    alt=""
                                    className="logo-img"
                                />
                            </div>

                            <div className="institute-name">{setting?.name}</div>

                            <div className="small institute-meta">
                                {[setting?.village, setting?.district, setting?.state, setting?.pin_code]
                                    .filter(Boolean)
                                    .join(", ")}
                            </div>

                            <div className="small institute-meta">
                                Mobile No: {setting?.mobile}
                                {setting?.secondary_mobile && `, ${setting?.secondary_mobile}`}
                            </div>

                        </div>

                        {/* Student Photo */}
                        <div className="col-3 text-end">
                            {data?.profile_picture ? (
                                <img
                                    src={imgBaseUrl + data?.profile_picture}
                                    className="photo-box"
                                    alt=""
                                />
                            ) : (
                                <div className="photo-box d-flex align-items-center justify-content-center ms-auto">
                                    <span className="small text-muted">Photo</span>
                                </div>
                            )}
                        </div>

                    </div>

                    <div className="row g-2 mb-3 align-items-center">
                        <div className="col-3 fw-bold">
                            Branch
                        </div>

                        <div className="col-9 field-box">
                            {client?.username?.toUpperCase() ?? ""}
                        </div>
                    </div>

                    <div className="row g-2 mb-3 align-items-center ">
                        <div className="col-3 fw-bold">
                            Course Applied For
                        </div>

                        <div className="col-9 field-box">
                            {data?.student_batch_info?.course?.title ?? ""}
                        </div>
                    </div>

                    <p className="declaration-text mb-6">
                        I want to take Admission. I have read the "terms &amp; conditions" of the institute
                        mentioned in the prospectus and given overleaf. I agree to abide by the same. My
                        particulars are given below.
                    </p>

                    <div className="instruction-banner mb-4">
                        It is compulsory to fill the form clearly in CAPITAL LETTERS only.
                    </div>

                    <div className="row g-2 mb-6 ">
                        <div className="col-6">
                            <span className="fw-bold">First Name </span>
                            <span className="field-line">{firstName}</span>
                        </div>
                        <div className="col-6">
                            <span className="fw-bold">Last Name </span>
                            <span className="field-line">{lastName}</span>
                        </div>
                    </div>

                    <div className="row g-2 mb-6">
                        <div className="col-6">
                            <span className="fw-bold">Father's/Guardian Name </span>
                            <span className="field-line">{data?.father_name}</span>
                        </div>
                        <div className="col-6">
                            <span className="fw-bold">Occupation </span>
                            <span className="field-line">{data?.father_occupation}</span>
                        </div>
                    </div>

                    <div className="row g-2 mb-6">
                        <div className="col-12">
                            <span className="fw-bold">Mother's Name </span>
                            <span className="field-line w-75">{data?.mother_name}</span>
                        </div>
                    </div>

                    <div className="row g-2 mb-6 align-items-center">
                        <div className="col-5">
                            <span className="fw-bold">Date of Birth </span>
                            <span className="field-line">{formatToDate(data?.dob)}</span>
                        </div>
                        <div className="col-4 d-flex align-items-center">
                            <span className="fw-bold me-2">Gender</span>
                            <span className={`checkbox-box me-1 ${isMale ? "checked" : ""}`}>M</span>
                            <span className={`checkbox-box ${isFemale ? "checked" : ""}`}>F</span>
                        </div>
                        <div className="col-3">
                            <span className="fw-bold">Category </span>
                            <span className="field-line">{data?.category}</span>
                        </div>
                    </div>

                    <div className="mb-6">
                        <div className="mb-6" >
                            <span className="fw-bold">Residence Address :</span>
                            <span className="field-line w-75">{[data?.village, data?.district].filter(Boolean).join(", ")}</span>
                        </div>

                        <div className="address-line"></div>
                    </div>

                    <div className="row g-2 mb-6">
                        <div className="col-4">
                            <span className="fw-bold">City </span>
                            <span className="field-line">{data?.village}</span>
                        </div>
                        <div className="col-4">
                            <span className="fw-bold">State </span>
                            <span className="field-line">{data?.state}</span>
                        </div>
                        <div className="col-4">
                            <span className="fw-bold">Pincode </span>
                            <span className="field-line">{data?.zipcode}</span>
                        </div>
                    </div>

                    <div className="row g-2 mb-6">
                        <div className="col-6">
                            <span className="fw-bold">Mobile (Parent's Number) </span>
                            <span className="field-line">{data?.secondary_mobile}</span>
                        </div>
                        <div className="col-6">
                            <span className="fw-bold">Mobile (Student's Number) </span>
                            <span className="field-line">{data?.phone}</span>
                        </div>
                    </div>

                    <div className="mb-6">
                        <span className="fw-bold">Email ID </span>
                        <span className="field-line w-75">{data?.email}</span>
                    </div>


                    <div className="mb-6">
                        <div className="mb-6" >
                            <span className="fw-bold">Address for Correspondence  </span>
                            <span className="field-line w-75">{[data?.village, data?.district].filter(Boolean).join(", ")}</span>
                        </div>

                        <div className="address-line"></div>
                    </div>

                    <div className="row g-2 mb-6">
                        <div className="col-4">
                            <span className="fw-bold">City </span>
                            <span className="field-line">{data?.village}</span>
                        </div>
                        <div className="col-4">
                            <span className="fw-bold">State </span>
                            <span className="field-line">{data?.state}</span>
                        </div>
                        <div className="col-4">
                            <span className="fw-bold">Pincode </span>
                            <span className="field-line">{data?.zipcode}</span>
                        </div>
                    </div>

                    <div className="section-bar">Academic Qualification</div>
                    <table className="table table-bordered academic-table">
                        <thead>
                            <tr>
                                <th>S.No.</th>
                                <th>Institution / Board / University</th>
                                <th>Subject</th>
                                <th>Percentage / CGPA</th>
                                <th>Year</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.documents && data.documents.length > 0
                                ? data.documents.map((detail, i) => (
                                    <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td>{detail?.school_name || '-'}</td>
                                        <td></td>
                                        <td>{detail?.score || '-'}</td>
                                        <td>{detail?.education_year || '-'}</td>
                                    </tr>
                                ))
                                : ["10th", "12th", "Graduation", "Other"].map((label, i) => (
                                    <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td>{label}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>

                {/* ---------------- BACK PAGE ---------------- */}
                <div className="a4-page-3 p-3">
                    <div className="corner-ribbon" aria-hidden="true"></div>
                    <div className="bottom-accent-bar" aria-hidden="true"></div>
                    {!setting?.logo_img && (
                        <div className="watermark-text" aria-hidden="true">
                            {setting?.name}
                        </div>
                    )}

                    <div className="section-heading">Terms &amp; Conditions :</div>
                    <div
                        className="terms-list"
                        dangerouslySetInnerHTML={{
                            __html: setting?.admission_form_terms_conditions || "",
                        }}
                    />

                    <div className="row mt-4 mb-6 align-items-end">
                        <div className="col-6">
                            <div className="mb-6">
                                <span className="fw-bold">Batch Timing </span>
                                <span className="field-line w-75">
                                    {formatTime(data?.student_batch_info?.batch?.start_time)}
                                    {" - "}
                                    {formatTime(data?.student_batch_info?.batch?.end_time)}
                                </span>
                            </div>
                            <div className="mb-6">
                                <span className="fw-bold">Date of Joining </span>
                                <span className="field-line w-75">{formatToDate(data?.admission_date)}</span>
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="fw-bold mb-1">Batch Option</div>
                            <div className="mb-1">
                                <span className={`checkbox-box me-2 ${isOnline ? "checked" : ""}`}></span>
                                Online
                            </div>
                            <div>
                                <span className={`checkbox-box me-2 ${isOffline ? "checked" : ""}`}></span>
                                Offline
                            </div>
                        </div>
                        <div className="col-3 text-center">
                            <div className="signature-box"></div>
                            <div className="small mt-1">Signature of the Candidate</div>
                        </div>
                    </div>

                    <div className="section-heading mt-3">For Office Use :-</div>
                    <div className="row g-2 mb-6">
                        <div className="col-6">
                            <span className="fw-bold">Course Name </span>
                            <span className="field-line w-75">{data?.student_batch_info?.course?.title}</span>
                        </div>
                        <div className="col-6">
                            <span className="fw-bold">Course Fees </span>
                            <span className="field-line w-75">{data?.student_batch_info?.total_fee}</span>
                        </div>
                    </div>

                    <div className="row g-2 mb-2 align-items-center">
                        <div className="col-6">
                            <span className={`checkbox-box me-2 ${isInstallment ? "checked" : ""}`}>
                                {isInstallment ? "✓" : ""}
                            </span>
                            Installment

                            <span className={`checkbox-box ms-4  me-2 ${isFullPayment ? "checked" : ""}`}>
                                {isFullPayment ? "✓" : ""}
                            </span>
                            Full Payment


                        </div>
                        <div className="col-6">
                            <span className="fw-bold">Registration Date </span>
                            <span className="field-line">{formatToDate(data?.admission_date)}</span>
                        </div>
                    </div>

                    <table className="table table-bordered installment-table mb-3">
                        <thead>
                            <tr>
                                <th>Inst. No.</th>
                                <th>Due Date</th>
                                <th>Due Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.student_batch_info?.emi?.length > 0
                                ? data.student_batch_info.emi.map((item, index) => (
                                    <tr key={item.id}>
                                        <td>{index + 1}</td>
                                        <td>{formatToDate(item?.emi_date)}</td>
                                        <td>{item?.emi_amount}</td>
                                    </tr>
                                ))
                                : [1, 2, 3].map((i) => (
                                    <tr key={i}>
                                        <td className="py-3"></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>

                    <div className="row">
                        <div className="col-6">
                            <span className="fw-bold">Received Registration Fees </span>
                            <span className="field-line">{data?.student_batch_info?.reg_fee ?? '0'}</span>
                        </div>
                        <div className="col-6 text-center">
                            <div className="signature-box ms-auto">
                                {setting?.auto_signature === "Yes" &&
                                    setting?.signature && (
                                        <img
                                            src={imgBaseUrl + setting.signature}
                                            alt="Signature"
                                            style={{
                                                maxWidth: "100%",
                                                maxHeight: "100%",
                                                objectFit: "contain",
                                            }}
                                        />
                                    )}
                            </div>
                            <div className="small mt-1">Auth. Signature</div>
                        </div>
                    </div>
                </div>
            </div>



        </>
    );
}